// determines which game cards are in the visible area of a horizontally scrolling row
function cardRightEdgeVisible(card, row, offset) {
  const cardRightEdge = card.getBoundingClientRect().right;
  const rowRightEdge = row.getBoundingClientRect().right;
  return cardRightEdge - offset <= rowRightEdge;
}

function cardLeftEdgeVisible(card, row, offset) {
  const cardLeftEdge = card.getBoundingClientRect().left;
  const rowLeftEdge = row.getBoundingClientRect().left;
  return cardLeftEdge + offset >= rowLeftEdge;
}

function determineVisibleCards(cards, row, callback) {
  // offset to allow cards to not completely enter the field in order to be considered 'visible'
  const cardOffsetPx = 70;
  const visibleCards = cards.filter(
    card => cardRightEdgeVisible(card, row, cardOffsetPx) && cardLeftEdgeVisible(card, row, cardOffsetPx)
  );
  callback(visibleCards);
}

export default determineVisibleCards;
